<template>
     <div class="certificate-header d-flex align-items-center justify-content-center flex-column ">
        <div class="certificate-title">{{ title }} </div>
        <div class="certificate-title-underline"></div>


    </div>
</template>

<script>
export default {
    props: {
         title:{
      type: String,
      default: () => 'صفحة',

    },
}
}
</script>

